import { createContext, useContext, useEffect, useState } from "react";

const RoleContext = createContext(null);
const STORAGE_KEY = "premierlab.role";
const ADMIN_ROLES = ["platform_admin", "super_admin"];

export function RoleProvider({ children }) {
  const [role, setRole] = useState(() => {
    if (typeof window === "undefined") return "user";
    return localStorage.getItem(STORAGE_KEY) || "user";
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, role);
  }, [role]);

  const isAdmin = ADMIN_ROLES.includes(role);

  return (
    <RoleContext.Provider value={{ role, setRole, isAdmin }}>
      {children}
    </RoleContext.Provider>
  );
}

export function useRole() {
  const ctx = useContext(RoleContext);
  if (!ctx) throw new Error("useRole must be used inside RoleProvider");
  return ctx;
}
